module.exports = "<div *ngIf=\"imgSrc\" class=\"pop-up-dialog-wrapper\">\r\n  <img (click)=\"close()\" class=\"close-icon\" src=\"/assets/img/close.png\">\r\n\r\n  <img src=\"{{imgSrc}}\" />\r\n</div>\r\n<div class=\"back-click-blocker\" (click)=\"$event.stopPropagation()\">\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/image-preview/image-preview.component.html
// module id = ../../../../../src/app/shared/image-preview/image-preview.component.html
// module chunks = main